<template>
    <div class="app-container">
        <!-- 查询条件 -->
        <div class="search-div common-section-bg">
            <div class="shaixuan-item">
                <el-input v-model="queryParam.name" size="mini" clearable placeholder="请输入姓名查找" />
            </div>
            <div class="shaixuan-item">
                <el-input v-model="queryParam.phone" size="mini" clearable placeholder="请输入电话查找" />
            </div>
            <div class="shaixuan-item">
                <el-date-picker v-model="publish_time" type="daterange" align="right" start-placeholder="变动时间起"
                    end-placeholder="变动时间止" :default-time="['00:00:00', '23:59:59']" value-format="yyyy-MM-dd">
                </el-date-picker>
            </div>
            <div class="shaixuan-item">
                <el-button type="primary" style="background: #1890ff; border-color: #1890ff" @click="searchClick()"
                    icon="el-icon-search">
                    查询
                </el-button>
            </div>
        </div>
        <!-- 列表展示 -->
        <div class="common-section-bg common-section-body">
            <el-table v-loading="listLoading" :data="tableData" size="mini" style="width: 100%; min-height: 300px">
                <el-table-column prop="id" label="id" width="80" />
                <el-table-column prop="name" label="用户姓名" width="100" >
                    <template slot-scope="scope">
                        <span>{{ (scope.row.user && scope.row.user.name) || "--" }}</span>
                    </template> 
                </el-table-column>
                <el-table-column prop="phone" label="联系电话" minWidth="120">
                    <template slot-scope="scope">
                        <span>{{ (scope.row.user && scope.row.user.phone) || "--" }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="user_points" label="用户积分" minWidth="100" />
                <el-table-column prop="yinbao_points" label="食堂积分" minWidth="100" />
                <el-table-column prop="youzan_points" label="商城积分" minWidth="100" />
                <el-table-column prop="type" label="类型" minWidth="100" >
                    <template slot-scope="scope">
                        <el-tag type="success" v-if="scope.row.type == 1">增加</el-tag>
                        <el-tag type="danger" v-if="scope.row.type == 2">减少</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="remark" label="备注" minWidth="150" />
                <el-table-column prop="created_at" label="变动时间" minWidth="150" />
            </el-table>
            <!-- 分页 -->
            <pagination v-show="total" :total="total" :page.sync="queryParam.page" :limit.sync="queryParam.size"
                @pagination="getList" />
        </div>
    </div>
</template>

<script>
import Pagination from "@/components/Pagination"; // 分页
import jifen from "@/api/tianzheng/jifen"; // 积分接口
export default {
    data() {
        return {
            publish_time: [],
            queryParam: {
                commId: "", // 小区id
                name: "", // 姓名
                phone: "", // 电话
                bgn_date: "",
                end_date: "",
                page: 1,
                size: 10,
                pay_type: 0,
                begin_score: "",
                end_score: ""
            },
            total: 0,
            listLoading: false,
            tableData: [],
            showDrawer: false
        };
    },
    components: {
        Pagination,
    },
    created() { },
    mounted() {
        this.getList();
    },
    methods: {
        searchClick() {
            if (this.publish_time.length > 0) {
                this.queryParam.bgn_date = this.publish_time[0] + " 00:00:00";
                this.queryParam.end_date = this.publish_time[1] + " 23:59:59";
            } else {
                this.queryParam.bgn_date = "";
                this.queryParam.end_date = "";
            }
            this.getList();
        },
        /* 查询tableData数据 */
        getList() {
            this.listLoading = true;
            jifen.list(this.queryParam).then(res => {
                this.listLoading = false;
                this.tableData = res.result.list;
                this.total = res.result.total;
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.app-container {
    min-height: calc(100vh - 98px);
}
</style>
